/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"
import { PriceGroupsFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type PriceGroupsQueryVariables = Exact<{ [key: string]: never }>

export type PriceGroupsQuery = {
  __typename: "Query"
  priceGroups: {
    __typename: "PriceGroups"
    id: string
    values?: Array<string> | null
  }
}

export const PriceGroupsDocument = gql`
  query PriceGroups {
    priceGroups
      @rest(type: "PriceGroups", path: "/price/products/price-groups") {
      ...PriceGroups
    }
  }
  ${PriceGroupsFragmentDoc}
`

/**
 * __usePriceGroupsQuery__
 *
 * To run a query within a React component, call `usePriceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePriceGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PriceGroupsQuery,
    PriceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PriceGroupsQuery, PriceGroupsQueryVariables>(
    PriceGroupsDocument,
    options
  )
}
export function usePriceGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PriceGroupsQuery,
    PriceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PriceGroupsQuery, PriceGroupsQueryVariables>(
    PriceGroupsDocument,
    options
  )
}
// @ts-ignore
export function usePriceGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PriceGroupsQuery,
    PriceGroupsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<PriceGroupsQuery, PriceGroupsQueryVariables>
export function usePriceGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PriceGroupsQuery,
        PriceGroupsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  PriceGroupsQuery | undefined,
  PriceGroupsQueryVariables
>
export function usePriceGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PriceGroupsQuery,
        PriceGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PriceGroupsQuery, PriceGroupsQueryVariables>(
    PriceGroupsDocument,
    options
  )
}
export type PriceGroupsQueryHookResult = ReturnType<typeof usePriceGroupsQuery>
export type PriceGroupsLazyQueryHookResult = ReturnType<
  typeof usePriceGroupsLazyQuery
>
export type PriceGroupsSuspenseQueryHookResult = ReturnType<
  typeof usePriceGroupsSuspenseQuery
>
export type PriceGroupsQueryResult = Apollo.QueryResult<
  PriceGroupsQuery,
  PriceGroupsQueryVariables
>
